import { Controller } from "@hotwired/stimulus"

// Toggles [data-theme] on <html> and persists via PATCH to ui_preferences.
// Values:
//   - userId (Number) — when set, persists server-side
//   - theme (String) — current theme; mirrored to <html data-theme>
export default class extends Controller {
  static values = { userId: Number, theme: String }

  connect() {
    if (!this.themeValue) {
      this.themeValue = document.documentElement.getAttribute("data-theme") || "light"
    }
    this.#applyTheme(this.themeValue)
  }

  toggle(event) {
    event?.preventDefault?.()
    const next = this.themeValue === "dark" ? "light" : "dark"
    this.set(next)
  }

  set(theme) {
    this.themeValue = theme
    this.#applyTheme(theme)
    this.#persist(theme)
  }

  setLight() { this.set("light") }
  setDark()  { this.set("dark") }
  setAuto()  { this.set("auto") }

  #applyTheme(theme) {
    document.documentElement.setAttribute("data-theme", theme)
  }

  async #persist(theme) {
    if (!this.hasUserIdValue) return
    try {
      const csrf = document.querySelector('meta[name="csrf-token"]')?.content
      await fetch(`/users/${this.userIdValue}/ui_preferences`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrf,
          "Accept": "application/json"
        },
        body: JSON.stringify({ ui_preferences: { theme } })
      })
    } catch (e) {
      console.warn("[theme] persist failed", e)
    }
  }
}
